import * as React from "react";
const SvgFiRrBroccoli = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-broccoli_svg__a)">
      <path
        fill="#062147"
        d="M20.794 6.206a4.43 4.43 0 0 0-4.6-3.194C13.509-1.852 5.916-.445 5.083 5c-7.24.463-6.488 10.65.74 10.934a17.5 17.5 0 0 1 1.037 4.45A4.027 4.027 0 0 0 10.842 24h2.316a4.027 4.027 0 0 0 3.982-3.615c.165-1.899.67-3.753 1.493-5.473 5.567.988 7.548-6.974 2.16-8.706m-5.643 13.96A2.027 2.027 0 0 1 13.158 22h-2.316a2.027 2.027 0 0 1-1.993-1.834 20.3 20.3 0 0 0-.913-4.266 8.1 8.1 0 0 0 2.573-.989q.235.17.49.31V19a1 1 0 0 0 2 0v-3.074c1.1.19 2.231.024 3.229-.475a19.7 19.7 0 0 0-1.077 4.714M19.5 13a2.52 2.52 0 0 1-1.564-.565A2.72 2.72 0 0 1 17 10a1 1 0 0 0-2 0 4.7 4.7 0 0 0 .969 3.255 3.425 3.425 0 0 1-4.6-.264 1 1 0 0 0-1.33-.15A5.75 5.75 0 0 1 6.999 14c-2.28 0-5-.695-5-4a3 3 0 0 1 3-3 2.808 2.808 0 0 1 3 3 1 1 0 1 0 2 0 5 5 0 0 0-2.944-4.547A4 4 0 0 1 14.7 4.5a1 1 0 0 0 1.178.592 2.477 2.477 0 0 1 3.083 2.085 1 1 0 0 0 .86.862A2.493 2.493 0 0 1 19.5 13"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-broccoli_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBroccoli;
